import { Button } from "@/components/ui/button";
import { Layers, Loader2 } from 'lucide-react';
import { useCreate, useNotify, useRecordContext } from 'ra-core';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import type { DesignRequest } from '../types';

export const CreateDesignBoMButton = () => {
    const record = useRecordContext<DesignRequest>();
    const navigate = useNavigate();
    const notify = useNotify();
    const [create] = useCreate();
    const [loading, setLoading] = useState(false);

    if (!record || record.status !== 'approved') return null;

    const handleCreate = async () => {
        setLoading(true);
        try {
            create(
                'boms',
                {
                    data: {
                        project_id: record.project_id,
                        design_request_id: record.id,
                        reference: `BOM-${record.reference}`,
                        version: 1,
                        status: 'draft',
                        items: [], // Start empty for user to fill
                        total_estimated_cost: 0
                    }
                },
                {
                    onSuccess: (data: any) => {
                        notify('BoM Draft created successfully', { type: 'success' });
                        navigate(`/boms/${data.id}/show`);
                    },
                    onError: (error: any) => {
                        notify(`Error creating BoM: ${error.message}`, { type: 'error' });
                    }
                }
            );
        } catch (error: any) {
            notify(`Error: ${error.message}`, { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button 
            variant="default" 
            size="sm" 
            onClick={handleCreate}
            disabled={loading}
            className="gap-2 bg-indigo-600 hover:bg-indigo-700 text-white"
        >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Layers className="w-4 h-4" />}
            Create BoM from Design
        </Button>
    );
};
